import { createApi } from '@reduxjs/toolkit/query/react';

import { AuthService } from 'shared/lib/keycloak';
import { baseQuery } from 'shared/lib/redux';
import { loggerService } from 'shared/lib/logger';

import { normalizeTeacherClassesResponse } from './lib';
import { getOnboardingUrl } from './constants';
import { TeacherClass, OnboardingUserInfoResponse, User } from './types';

export const onboardingApi = createApi({
  reducerPath: 'onboarding',
  baseQuery: baseQuery(getOnboardingUrl),
  endpoints: (builder) => ({
    getTeacherClasses: builder.query<TeacherClass[], void>({
      query: () =>
        `ims/oneroster/v1p1/users/${AuthService.getUserBk()}/classes?filter=status='active'`,
      transformResponse: normalizeTeacherClassesResponse,
      async onQueryStarted(queryArg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (e) {
          loggerService.logError('Teacher classes loading error', e);
        }
      },
    }),
    getOnboardingUserInfo: builder.query<User | undefined, string>({
      query: (userBk) => `ims/oneroster/v1p1/users/${userBk}`,
      transformResponse: (res: OnboardingUserInfoResponse) => res.user,
      async onQueryStarted(userBk, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (e) {
          loggerService.logError('Onboarding user info loading error', e);
        }
      },
    }),
  }),
  keepUnusedDataFor: 60000,
});

export const { useGetTeacherClassesQuery, useGetOnboardingUserInfoQuery } =
  onboardingApi;
